import React from 'react';

import ExpandableProjectList, {
  ExpandableProjectListHeader,
} from '../../components/ExpandableProjectList';
import ImageIconHeader from '../../components/ImageIconHeader';
import ReportsTable from '../../components/ReportsTable';
import RunsTable, {
  RunsTableRun,
  runsTableRunFromQueryData,
} from '../../components/RunsTable';
import {Section, SectionHeader} from '../../components/Section';
import {Graph, Project} from '../../types/graphql';
import {propagateErrorsContext} from '../../util/errors';
import {ProjectSkeletons} from '../ProfilePage/LoadableProjectList';
import {
  useEntityRunsQuery,
  useTeamPageProjectsTwoQuery,
} from './../../generated/graphql';
// import {CreateReportPrompt} from './../../components/Reports';
// import {useCreateReportInProject} from './../../components/Reports/CreateReportPrompt/useCreateReportInProject';
// import {useCreateReportPromptProjectData} from './../../components/Reports/CreateReportPrompt/useCreateReportPromptProjectData';
import {MimicTable} from './MimicTable';
import {useTeamPageProjects} from './useTeamProjects';
// import {usePushReport} from 'src/state/reports/hooks';

interface TeamOverviewProps {
  entityName: string;
  isReadOnly: boolean;
}

const TeamOverviewComp = ({entityName, isReadOnly}: TeamOverviewProps) => {
  const {data: entityRunsData, loading: isEntityRunsLoading} =
    useEntityRunsQuery({
      variables: {entityName},
      context: propagateErrorsContext(),
    });
  const {data: teamPageProjectsData, loading: teamPageProjectsLoading} =
    useTeamPageProjects(entityName);
  const {data: tp2, loading: tp2Loading} = useTeamPageProjectsTwoQuery({
    variables: {
      entityName,
      first: 6,
    },
  });
  // const promptProject = useCreateReportPromptProjectData(entityName);
  // const createReportInProject = useCreateReportInProject("Team overview page")
  const reportEdges = {
    edges:
      teamPageProjectsData?.entity?.runs.map(r => ({
        node: r,
      })) ?? [],
  };

  // const pushReport = usePushReport(entityName, promptProject?.node.name, true);
  const runData: Graph<RunsTableRun> = runsTableRunFromQueryData(
    entityRunsData?.entity?.latestRuns
  );
  return (
    <>
      <Section>
        <SectionHeader>
          <ExpandableProjectListHeader
            entityName={entityName}
            isReadOnly={isReadOnly}
          />
        </SectionHeader>
        {tp2Loading ? (
          <ProjectSkeletons entityName={entityName} />
        ) : (
          <ExpandableProjectList
            entityName={entityName}
            isReadOnly={isReadOnly}
            projects={
              (tp2?.entity?.projects as unknown as Graph<Project>) ?? {}
            }
            suppressHeader
          />
        )}
      </Section>

      <Section>
        <SectionHeader>
          <ImageIconHeader icon="run" text="Runs" />
        </SectionHeader>
        {isEntityRunsLoading ? (
          <MimicTable
            columnNames={['Name', 'Project', 'State', 'Created', 'User']}
            numRows={10}
          />
        ) : (
          <RunsTable name="Runs" data={runData} showUserColumn suppressHeader />
        )}
      </Section>

      <Section>
        {(teamPageProjectsLoading ||
          (!teamPageProjectsLoading && reportEdges.edges.length > 0)) && (
          <SectionHeader>
            <ImageIconHeader icon="report" text="Reports" />
          </SectionHeader>
        )}

        {teamPageProjectsLoading && (
          <MimicTable
            columnNames={['Title', '', 'Project', 'Author', 'Last Edit']}
            columnSizes={'22fr 4.5fr 15fr 13fr 13fr'}
            numRows={10}
          />
        )}
        {!teamPageProjectsLoading && reportEdges.edges.length > 0 && (
          <ReportsTable data={reportEdges} pageSize={10} suppressHeader />
        )}
        {
          // TODO: figure out logic for showing prompt when user is a
          // member of the team and the team doesn't have reports
        }
        {/* {!teamPageProjectsLoading &&
          reportEdges.edges.length === 0 &&
          promptProject && (
            <CreateReportPrompt
              entityName={promptProject.entityName}
              location={'Team Overview'}
              projectName={promptProject.name}
              onCreateReport={() => {
                createReportInProject(
                  the username,
                  the project name
                )
              }}
            />
          )} */}
      </Section>
    </>
  );
};
export const TeamOverview = React.memo(TeamOverviewComp);
